import axios from 'axios';
import React, { useState } from 'react';
import { exchangeRates } from '../../data/regions';
import { AmazonDailySalesScreen } from '../../screens/AmazonDailySalesScreen/AmazonDailySalesScreen';
import csvDataToJSON from '../../utils/csvDataToJson';
import { intVat } from '../../data/XRandTax';

export const AmazonDailySales = (props) => {
  
  const [amazonReport, setAmazonReport] = useState('');
  const [amazonReportOutput, setAmazonReportOutput] = useState('');

  async function handleOnSubmit() {
    let amazonSalesJson = csvDataToJSON(amazonReport, 0); //2nd arg is parent id
    //filter out cancelled orders and non-amazon orders (eg when returning FBA stock)
    amazonSalesJson = Object.values(amazonSalesJson).filter(order => order['order-status'] !== 'Cancelled' && order['sales-channel'] !== 'Non-Amazon')
    
    //amazonSalesJson.filter((order) => order['order-status'] !== 'Cancelled')
    let amazonSales = {};
    Object.values(amazonSalesJson).forEach((sale) => {
      amazonSales[sale['amazon-order-id']] = {};
      //amazonSalesJson is messing up on the input paste as product names contain tabs - look into what can do server side when online
      amazonSales[sale['amazon-order-id']].shippingCountry = lookUpSalesChannel(sale['sales-channel']);
      amazonSales[sale['amazon-order-id']].asin = sale.asin;
      amazonSales[sale['amazon-order-id']].sku = sale.sku;
      amazonSales[sale['amazon-order-id']].currency = sale.currency;
      amazonSales[sale['amazon-order-id']].purchaseDate = sale['purchase-date'];

      //us is under a different field
      if (amazonSales[sale['amazon-order-id']].shippingCountry === 'us') {
        amazonSales[sale['amazon-order-id']].exVatSalePrice =
          sale['item-price'] / exchangeRates[lookUpSalesChannel(sale['sales-channel'])];
        amazonSales[sale['amazon-order-id']].exVatShippingSalePrice =
          sale['shipping-price'] / exchangeRates[lookUpSalesChannel(sale['sales-channel'])];
        amazonSales[sale['amazon-order-id']].shipServiceLevel = sale['ship-service-level'];
        //gb sales include vat for some reason
      } else if (amazonSales[sale['amazon-order-id']].shippingCountry === 'gb') {
        amazonSales[sale['amazon-order-id']].exVatSalePrice =
          sale['item-price'] / exchangeRates[lookUpSalesChannel(sale['sales-channel'])] / 1.2;
        amazonSales[sale['amazon-order-id']].exVatShippingSalePrice =
          sale['shipping-price'] / exchangeRates[lookUpSalesChannel(sale['sales-channel'])];
        amazonSales[sale['amazon-order-id']].shipServiceLevel = sale['ship-service-level'] / 1.2;
      } else {
        amazonSales[sale['amazon-order-id']].exVatSalePrice =
          sale['vat-exclusive-item-price'] / exchangeRates[lookUpSalesChannel(sale['sales-channel'])];
        amazonSales[sale['amazon-order-id']].exVatShippingSalePrice = sale['vat-exclusive-shipping-price'];
      }

      amazonSales[sale['amazon-order-id']].fba = sale['merchant-order-id'] ? true : false;
    });
    //fetch server side fields
    amazonSales = await fetchFieldsFromServer(amazonSales);
    setAmazonReportOutput(amazonSales);
    //how to handle FBA costs?????
  }

  function fetchFieldsFromServer(amazonSales) {
    return axios
      .post(process.env.REACT_APP_HOST + 'getAmazonDailySalesFields', amazonSales)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function lookUpSalesChannel(channel) {
    console.log(channel)
    switch (channel) {
      case 'Amazon.co.uk':
        return 'gb';
      case 'Amazon.de':
        return 'de';
      case 'Amazon.fr':
        return 'fr';
      case 'Amazon.es':
        return 'es';
      case 'Amazon.it':
        return 'it';
      case 'Amazon.nl':
        return 'nl';
      case 'Amazon.se':
        return 'se';
      case 'Amazon.pl':
        return 'pl';
      case 'Amazon.com':
        return 'us';
    }
  }

  return (
    <AmazonDailySalesScreen
      amazonReport={amazonReport}
      handleOnSubmit={handleOnSubmit}
      setAmazonReport={setAmazonReport}
      amazonReportOutput={amazonReportOutput}
    />
  );
};
